import {CoolResource, CoolService} from '../service/cool.service';
import {Factory} from './factory';
import {Observable} from 'rxjs';
import {HttpParams} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {CompanyLookup} from './company-lookup';

export class LookupResource<T> {

  readonly service: CoolService;
  readonly resource: CoolResource;
  readonly type: string;
  readonly factory: Factory<T>;

  constructor(coolService: CoolService, type: string, factory: Factory<T>) {
    this.service = coolService;
    this.resource = CoolResource.Lookup;
    this.type = type;
    this.factory = factory;
  }

  _lookup(params: HttpParams): Observable<T> {
    return this.service.getResourceWithParams<T>(this.resource, this.type, params, this.factory);
  }

  _lookupArray(params: HttpParams): Observable<T[]> {
    return this.service.getArrayResourceWithParams<T>(this.resource, this.type, params, this.factory);
  }
}

@Injectable()
export class CompanyLookupResource extends LookupResource<CompanyLookup> {
  constructor(service: CoolService) {
    super(service, 'company', CompanyLookup.copy);
  }

  lookup(businessId: string): Observable<CompanyLookup> {
    return this._lookup(new HttpParams()
      .set('businessId', businessId)
    );
  }
}
